export const REACT_APP_MIDDLEWARE_URL =
  process.env.REACT_APP_MIDDLEWARE_URL || "__MIDDLEWARE_URL__";
export const REACT_APP_GERS_API_URL =
  process.env.REACT_APP_GERS_API_URL || "__GERS_API_URL__";
export const REACT_APP_BASE_URL =
  process.env.REACT_APP_BASE_URL || "__GERS_BASE_URL__";
export const REACT_APP_STORAGE_URL =
  process.env.REACT_APP_STORAGE_URL || "__STORAGE_URL__";
export const REACT_APP_DISABLE_CHECKOUT_PAYMENT_OPTIONS =
  process.env.REACT_APP_DISABLE_CHECKOUT_PAYMENT_OPTIONS ||
  "__DISABLE_CHECKOUT_PAYMENT_OPTIONS__";
export const REACT_APP_ESD_WAREHOUSE_ID =
  process.env.REACT_APP_ESD_WAREHOUSE_ID || "__AMSTERDAM_ESD_ID__";
export const REACT_APP_VILLAARENA_WAREHOUSE_ID =
  process.env.REACT_APP_VILLAARENA_WAREHOUSE_ID ||
  "__VLAARDINGEN_VILLAARENT_ID__";
export const REACT_APP_ENVIRONMENT =
  process.env.REACT_APP_ENVIRONMENT || "__REACT_APP_ENVIRONMENT__";
export const REACT_APP_LOCAL_STYLING =
  process.env.REACT_APP_LOCAL_STYLING || "false";
export const REACT_APP_GTM_TAG = process.env.REACT_APP_GTM_TAG || "__GTM_TAG__";
export const REACT_APP_VOUCHER_ENCRYPTION_KEY =
  process.env.REACT_APP_VOUCHER_ENCRYPTION_KEY ||
  "__REACT_APP_VOUCHER_ENCRYPTION_KEY__";

export const STORAGE_ORDER_KEY = "gewoongers_order_id";
export const STORAGE_PAYMENT_URL = "gewoongers_payment_url";
export const STORAGE_DELIVERY_OBJECT = "gewoongers_delivery_object";
export const STORAGE_PLAN_APPOINTMENT_LATER = "plan_appointment_later";
export const STORAGE_SALE_LOCATION = "gewoongers_sale_location";
export const STORAGE_IS_SAME_ADDRESS = "gewoongers_is_same_address";
export const STORAGE_PERSONAL_INFO_TYPE = "gewoongers_personal_info_type";
export const APPOINTMENT_TYPE_SEARCH_PARAM = "type";
